import {IconButton, Tooltip} from "@mui/material";
import {alpha, type Theme} from "@mui/material/styles";
import Build from "@mui/icons-material/Build";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {adminDashboardPath} from "../../routes";

const adminButtonSx = {
    width: 40,
    height: 40,
    border: "1px solid",
    borderColor: (theme: Theme) => alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.24 : 0.36),
    backgroundColor: (theme: Theme) => alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.1 : 0.18),
    color: "inherit",
    boxShadow: (theme: Theme) =>
        `0 2px 10px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.22 : 0.14)}`,
    backdropFilter: "blur(10px)",
    transition: "all 0.2s ease",
    "&:hover": {
        backgroundColor: (theme: Theme) => alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.18 : 0.28),
        borderColor: (theme: Theme) => alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.32 : 0.48),
        transform: "translateY(-1px)",
        boxShadow: (theme: Theme) =>
            `0 6px 16px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.28 : 0.18)}`,
    },
} as const;

const AdminButton: React.FC = () => {
    const navigate = useNavigate();
    const {t: translate} = useTranslation();

    return (
        <Tooltip title={translate("admin.openDashboard")}>
            <IconButton
                onClick={() => navigate(adminDashboardPath)}
                aria-label={translate("admin.openDashboard")}
                sx={adminButtonSx}
            >
                <Build sx={{fontSize: 20, color: "inherit"}}/>
            </IconButton>
        </Tooltip>
    );
};

export default AdminButton;
